// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 根据ID获取文件信息 根据文件ID获取文件记录信息

可用于查询已上传文件的信息，便于后续扩展功能。 GET /api/admin/files/${param0} */
export async function getFileEndpointApiAdminFilesFileIdGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getFileEndpointApiAdminFilesFileIdGetParams,
  options?: { [key: string]: any }
) {
  const { file_id: param0, ...queryParams } = params;
  return request<API.BaseResponseFileRecordResponse_>(
    `/api/admin/files/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 批量根据URL获取文件信息 批量根据文件URL获取文件记录信息

支持传入多个URL，返回对应的文件信息列表。
如果某个URL未找到对应的文件记录，则返回None。

## 请求参数

- `urls`: 文件URL列表（原始URL），最多100个

## 响应格式

- `items`: 文件信息列表，按请求URL顺序返回
- 如果某个URL未找到，对应位置为 `null`

## 使用场景

- 批量查询多个文件的信息
- 验证文件URL是否存在
- 获取文件元数据（大小、类型等） POST /api/admin/files/batch-by-url */
export async function batchGetFilesByUrlEndpointApiAdminFilesBatchByUrlPost(
  body: API.BatchGetFilesByUrlRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseBatchGetFilesByUrlResponse_>(
    "/api/admin/files/batch-by-url",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 根据URL获取文件信息 根据文件URL获取文件记录信息

支持基于URL查找，这是主要的查找方式。
可用于查询已上传文件的信息，便于后续扩展功能。 GET /api/admin/files/by-url */
export async function getFileByUrlEndpointApiAdminFilesByUrlGet(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getFileByUrlEndpointApiAdminFilesByUrlGetParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseFileRecordResponse_>(
    "/api/admin/files/by-url",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 上传文件（服务端中转） 通过服务端中转上传文件（降级方案）

管理端版本，用于运营后台上传文件。

适用于：
- 老版本浏览器不支持直传
- 需要在上传前进行文件校验
- 需要统一处理上传逻辑

注意：此方式会占用服务端带宽，建议优先使用直传方式。

## 请求参数

- `file`: 文件字段（multipart/form-data）
- `business_type`: 业务类型（Query参数，如：image/document/video）
- `custom_prefix`: 自定义路径前缀（Query参数，可选）

## 业务类型说明

支持的业务类型（business_type）：
- **avatar**: 用户头像（C端使用）
- **resume**: 简历文件（C端使用）
- **document**: 文档文件（如认证材料PDF）
- **image**: 通用图片（如企业Logo、环境媒体图片）
- **video**: 视频文件（如环境媒体视频）
- **audio**: 音频文件
- **other**: 其他类型文件

注意：管理端通常使用 `image`、`document`、`video`、`audio`、`other`，`avatar` 和 `resume` 主要用于C端。 POST /api/admin/files/upload */
export async function uploadFileEndpointApiAdminFilesUploadPost(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.uploadFileEndpointApiAdminFilesUploadPostParams,
  body: API.fastapi_Compat_v2_BodyUploadFileEndpointApiAdminFilesUploadPost,
  file?: File,
  options?: { [key: string]: any }
) {
  const formData = new FormData();

  if (file) {
    formData.append("file", file);
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele];

    if (item !== undefined && item !== null) {
      if (typeof item === "object" && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ""));
        } else {
          formData.append(
            ele,
            new Blob([JSON.stringify(item)], { type: "application/json" })
          );
        }
      } else {
        formData.append(ele, item);
      }
    }
  });

  return request<API.BaseResponseFileRecordResponse_>(
    "/api/admin/files/upload",
    {
      method: "POST",
      params: {
        ...params,
      },
      data: formData,
      requestType: "form",
      ...(options || {}),
    }
  );
}

/** 生成文件上传URL（直传） 生成文件直传签名URL（客户端直接上传到OSS）

管理端版本，用于运营后台上传文件（如企业Logo、认证材料、环境媒体等）。
客户端获取上传凭证后，直接以multipart/form-data格式POST文件到OSS，无需经过服务端中转，建议优先使用此方式。

## 使用流程

1. 调用此接口获取 `upload_url` 和 `form_data`
2. 构建multipart/form-data请求：
   - 将 `form_data` 中的所有字段作为表单字段（**必须原样透传，不能修改任何值**）
   - 添加一个名为 `file` 的文件字段，值为要上传的文件
3. POST到 `upload_url`，上传成功后可直接使用返回的 `file_url` 访问文件

## 关键说明

- **MIME类型自动识别**：服务端会根据文件名自动识别MIME类型，客户端无需传入，避免数据不一致
- **form_data字段必须原样透传**：`form_data` 中的所有字段都已签名，必须原样作为表单字段上传，不能修改任何值，否则OSS会拒绝上传（403错误）
- **客户端需要添加file字段**：表单中必须包含名为 `file` 的文件字段
- **不要设置Content-Type请求头**：上传时让客户端自动设置multipart边界，不要手动设置 `Content-Type` 请求头
- **上传凭证有效期**：默认1小时

## 业务类型说明

支持的业务类型（business_type）：
- **avatar**: 用户头像（C端使用）
- **resume**: 简历文件（C端使用）
- **document**: 文档文件（如认证材料PDF）
- **image**: 通用图片（如企业Logo、环境媒体图片）
- **video**: 视频文件（如环境媒体视频）
- **audio**: 音频文件
- **other**: 其他类型文件

注意：管理端通常使用 `image`、`document`、`video`、`audio`、`other`，`avatar` 和 `resume` 主要用于C端。

## 响应字段

- `file_id`: 文件记录ID，可用于后续查询和管理文件
- `upload_url`: OSS上传端点URL，POST文件到此URL
- `file_url`: 文件访问URL，上传成功后可直接使用
- `file_path`: 文件在OSS中的相对路径
- `form_data`: 表单字段字典，**所有字段必须原样透传到上传请求的表单中** POST /api/admin/files/upload-url */
export async function generateUploadUrlEndpointApiAdminFilesUploadUrlPost(
  body: API.GenerateUploadUrlRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseGenerateUploadUrlResponse_>(
    "/api/admin/files/upload-url",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
